export var Localhost = {
  chainId: 1337,
  chainName: 'Localhost',
  isTestChain: true,
  isLocalChain: true,
  multicallAddress: '',
  rpcUrl: 'http://localhost:8545',
  getExplorerAddressLink: function getExplorerAddressLink() {
    return '';
  },
  getExplorerTransactionLink: function getExplorerTransactionLink() {
    return '';
  }
};
export var Hardhat = {
  chainId: 31337,
  chainName: 'Hardhat',
  isTestChain: true,
  isLocalChain: true,
  multicallAddress: '',
  rpcUrl: 'http://localhost:8545',
  getExplorerAddressLink: function getExplorerAddressLink() {
    return '';
  },
  getExplorerTransactionLink: function getExplorerTransactionLink() {
    return '';
  }
};
export default {
  Localhost: Localhost,
  Hardhat: Hardhat
};